import { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://tnbx7rvcbc.us-east-1.awsapprunner.com/auth/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setMessage("Login successful!");
        navigate("/dashboard");
        // Save token or redirect user
        localStorage.setItem("token", "true");
      } else {
        setMessage(data.message || "Login failed.");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className="login_page_wrapper">
      <div className="header">
        <a href="/">
          <h1>Resource Library</h1>
        </a>
        {/* <a href="/login">Login</a> */}
      </div>
      <div className="login_form">
        <form
          onSubmit={handleSubmit}
          style={{ maxWidth: 400, margin: "0 auto" }}
        >
          <h2>Login</h2>
          <div className="input_line">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input_line">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            className="submit"
            style={{ cursor: "pointer" }}
            type="submit"
          >
            Login
          </button>
          <a className="back_home" href="/">
            Back To Home
          </a>
          {message && <p>{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
